const TRASH_KEY = 'inboxpulse_analysis_trash_v1';

export function loadTrash() {
  try {
    const raw = localStorage.getItem(TRASH_KEY);
    if (!raw) return [];
    const data = JSON.parse(raw);
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
}

export function persistTrash(items) {
  localStorage.setItem(TRASH_KEY, JSON.stringify(items));
}

/** Keep items trashed within the last maxAgeDays (drop older). */
export function pruneTrashByAge(items, maxAgeDays) {
  if (!maxAgeDays || maxAgeDays < 1 || !Array.isArray(items)) return items;
  const cutoff = Date.now() - maxAgeDays * 24 * 60 * 60 * 1000;
  return items.filter((entry) => {
    const t = new Date(entry.trashedAt || 0).getTime();
    return Number.isFinite(t) && t >= cutoff;
  });
}
